module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_04_6NW26_1SC_H2U.264972af.jpg";